import { __awaiter } from "tslib";
import { connect as natsConnect } from "nats.ws";
import './nttrtc/iface_discovery';
import { NegAnnouncer, parseAnnounce, parseSms, SelectArbiterTopic, bytesToString, stringToBytes } from './natsnegcommon';
//import { NatsStreamerSession } from './natsstreamersession'
import { NatsViewerSession } from './natsviewersession';
import "svelte/internal";
export var NatsState;
(function (NatsState) {
    NatsState[NatsState["NotConnected"] = 0] = "NotConnected";
    NatsState[NatsState["Connecting"] = 1] = "Connecting";
    NatsState[NatsState["Connected"] = 2] = "Connected";
})(NatsState || (NatsState = {}));
export class NatsNegConnection {
    constructor(opts, negOpts) {
        this.peers = {};
        this.discoDisconnectMsg = "";
        this.onConnectionStateChanged = () => { };
        this.onDiscoveredPeer = () => { };
        this.onLostPeer = () => { };
        this.jwt = negOpts.unsignedJwt;
        let allSubj = this.jwt.nats.pub.allow;
        for (let i = 0; i < allSubj.length; ++i) {
            if (allSubj[i].startsWith("neg.announce.")) {
                let a = parseAnnounce(allSubj[i]);
                this.role = a.role;
                this.pubKey = a.pubKey;
                break;
            }
        }
        new Promise(() => {
            this.emitOnConnectionStateChanged(NatsState.Connecting, "");
            natsConnect(opts).then((nc) => {
                this.nats = nc;
                let sub = this.nats.subscribe("neg.announce.*.*");
                sub.callback = (error, msg) => {
                    let msgData = JSON.parse(bytesToString(msg.data));
                    if (!msgData) {
                        return;
                    }
                    if (msgData["new"]) {
                        if (this.announcer) {
                            this.announcer.send({});
                        }
                    }
                    this.processAnnounce(msg, msgData);
                };
                this.emitOnConnectionStateChanged(NatsState.Connected, "");
            }).catch((err) => {
                this.emitOnConnectionStateChanged(NatsState.NotConnected, err);
            });
        });
    }
    emitOnDiscoveredPeer(msg) {
        this.onDiscoveredPeer(msg);
    }
    processAnnounce(msg, data) {
        if (data.gone) {
            delete this.peers[msg.subject];
            this.emitOnLostPeer(msg);
            return;
        }
        let updated = !!this.peers[msg.subject];
        this.peers[msg.subject] = { a: data, lastSeen: new Date().getTime() };
        if (!updated) {
            this.emitOnDiscoveredPeer(msg);
        }
    }
    emitOnLostPeer(msg) {
        this.onLostPeer(msg);
    }
    emitOnConnectionStateChanged(ns, reason) {
        if (ns == NatsState.Connected) {
            this.announcer = new NegAnnouncer(this.nats, this.role, this.pubKey);
            this.timeoutTimer = setInterval(() => {
                let now = new Date().getTime();
                for (let k in this.peers) {
                    let val = this.peers[k];
                    if ((now - val.lastSeen) > 25000) {
                        delete this.peers[k];
                        this.emitOnLostPeer({ subject: k, timeout: true });
                        break;
                    }
                }
            }, 5000);
        }
        else {
            if (this.announcer) {
                this.announcer.stop();
            }
            if (this.timeoutTimer) {
                clearInterval(this.timeoutTimer);
            }
            this.announcer = null;
        }
        this.onConnectionStateChanged(ns, reason);
    }
    buildMySms(topic, tgtRole, tgtPub) {
        if (tgtPub) {
            tgtRole = tgtRole + "." + tgtPub;
        }
        return `neg.${topic}.sms.${this.role}.${this.pubKey}.to.${tgtRole}`;
    }
    buildTunnel(helper, streamer, viewer) {
        return `neg.tunnel.${helper}.${streamer}.${viewer}`;
    }
    listenForViewers(opts) {
        let sub = this.nats.subscribe(buildSms(SelectArbiterTopic, "v", "*", "s", this.pubKey));
        sub.callback = (err, msg) => {
            let areq = JSON.parse(bytesToString(msg.data));
            console.log("Selarb", areq);
            let ares = { helper: areq.defHelper, sid: areq.defSid };
            if (ares.helper && ares.sid) {
                opts.statusCb("Creating LC", null);
                opts.factory.createLifecycle().then((lc) => {
                    opts.rtcLc = lc;
                    lc.pc.ontrack = opts.onTrack;
                    opts.statusCb("Created LC", null);
                    let smsFields = parseSms(msg.subject);
                    let sess = new NatsViewerSession(smsFields.sender, opts, this, "s");
                    sess.feedSid(ares.sid, ares.helper);
                    {
                        let found = false;
                        let prio = 0;
                        for (let k in this.peers) {
                            let val = this.peers[k];
                            let a = parseAnnounce(k);
                            if (a.role != 'h') {
                                continue;
                            }
                            if (k != ares.helper) {
                                continue;
                            }
                            if (val.a.ext_ip) {
                                for (let i in opts.localInfo.ifs) {
                                    let iface = opts.localInfo.ifs[i];
                                    if (iface.addr == val.a.ext_ip) {
                                        sess.feedCandidate(iface.cand, iface.relatedHostCandidate);
                                        break;
                                    }
                                }
                            }
                        }
                        if (!found) {
                            // If not found, fallback to the first proxy
                            console.log("Finding helper...", this);
                            for (let k in this.peers) {
                                let val = this.peers[k];
                                let a = parseAnnounce(k);
                                if (a.role != 'h' || !val.a.flags || val.a.flags.indexOf('p') == -1) {
                                    continue;
                                }
                                // TODO: find a proper cand
                                let iface = opts.localInfo.ifs[0];
                                sess.feedCandidate(iface.cand, iface.relatedHostCandidate);
                                break;
                            }
                        }
                    }
                    console.log("selarbres", ares);
                    msg.respond(stringToBytes(JSON.stringify(ares)));
                    sess.doOfferNeg();
                    sess.pushUpdate();
                });
            }
        };
    }
    // Returns when Stage 1 is complete
    startNeg(peer, opts) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            // Maybe suggest a helper based on LocalInfo
            var _a, _b;
            opts.statusCb("Creating LC", null);
            let lc = yield opts.factory.createLifecycle();
            opts.rtcLc = lc;
            lc.pc.ontrack = opts.onTrack;
            opts.statusCb("Created LC", null);
            let vc = new NatsViewerSession(peer, opts, this);
            vc.doOfferNeg().then(resolve, reject);
            console.log(`Considering peers`);
            let defHelper = "";
            let defSid = "";
            let profile = "default";
            {
                let prio = 0;
                for (let k in this.peers) {
                    let val = this.peers[k];
                    let a = parseAnnounce(k);
                    if (a.role != 'h') {
                        continue;
                    }
                    if (val.a.ext_ip && ((_a = opts.localInfo) === null || _a === void 0 ? void 0 : _a.ifs)) {
                        for (let i in opts.localInfo.ifs) {
                            let iface = opts.localInfo.ifs[i];
                            if (iface.addr == val.a.ext_ip) {
                                let sidReq = { priority: prio++, streamer: peer, profile: profile };
                                console.log("mksid", sidReq);
                                let rsp;
                                try {
                                    // DSZ: nats/sms/mksid/sendl, Request SID, local helper
                                    let natsRsp = yield this.nats.request(this.buildMySms("mksid", a.role, a.pubKey), stringToBytes(JSON.stringify(sidReq)), { timeout: 1000 });
                                    console.log(natsRsp);
                                    rsp = JSON.parse(bytesToString(natsRsp.data));
                                    if (!rsp.sid) {
                                        continue;
                                    }
                                }
                                catch (err) {
                                    // ignore
                                    console.log(err);
                                    continue;
                                }
                                defSid = rsp.sid;
                                defHelper = a.pubKey;
                                vc.feedCandidate(iface.cand, iface.relatedHostCandidate);
                                break;
                            }
                        }
                    }
                }
                // If not found, fallback to the first proxy
                console.log("Finding helper...", this);
                if (!defHelper || !defSid) {
                    for (let k in this.peers) {
                        let val = this.peers[k];
                        let a = parseAnnounce(k);
                        if (a.role != 'h' || !val.a.flags || val.a.flags.indexOf('p') == -1) {
                            continue;
                        }
                        let sidReq = { priority: prio++, streamer: peer, profile: profile };
                        let rsp;
                        try {
                            console.log("mksid", sidReq);
                            // DSZ: nats/sms/mksid/send1, Request SID, fallback helper
                            let natsRsp = yield this.nats.request(this.buildMySms("mksid", a.role, a.pubKey), stringToBytes(JSON.stringify(sidReq)), { timeout: 1000 });
                            console.log(natsRsp);
                            rsp = JSON.parse(bytesToString(natsRsp.data));
                            if (!rsp.sid) {
                                continue;
                            }
                        }
                        catch (err) {
                            // ignore
                            console.log(err);
                            continue;
                        }
                        defSid = rsp.sid;
                        defHelper = a.pubKey;
                        // TODO: find a proper cand
                        if ((_b = opts.localInfo) === null || _b === void 0 ? void 0 : _b.ifs) {
                            let iface = opts.localInfo.ifs[0];
                            if (iface) {
                                vc.feedCandidate(iface.cand, iface.relatedHostCandidate);
                            }
                        }
                        break;
                    }
                }
            }
            if (!defHelper || !defSid) {
                opts.statusCb("Cannot find a suitable helper", null);
                reject("Cannot find a suitable helper");
                return;
            }
            opts.statusCb("Settling sids", null);
            // DSZ: nats/sms/selarb/send, Send arbitration req
            // Send either preferred SID with a local extip acquired with nats/sms/mksid/sendl
            // or the SID from first available helper, acquired with nats/sms/mksid/send1
            let selArb = { defHelper: defHelper, defSid: defSid };
            let nr = yield this.nats.request(this.buildMySms(SelectArbiterTopic, "s", peer), stringToBytes(JSON.stringify(selArb)), { timeout: 2000 });
            let selArbRsp = JSON.parse(bytesToString(nr.data));
            console.log("Selected helper", selArbRsp.helper);
            opts.statusCb("Stage 1 confirmation", null);
            vc.feedSid(selArbRsp.sid, selArbRsp.helper);
            this.disco = opts.disco;
            let discoMsg = { msg: "unmonitor", sid: defSid, tunnel: this.buildTunnel(selArbRsp.helper, peer, this.pubKey) };
            this.discoDisconnectMsg = JSON.stringify(discoMsg);
            discoMsg.msg = "monitor";
            this.disco.send(JSON.stringify(discoMsg));
        }));
    }
    disconnect() {
        var _a;
        if (this.discoDisconnectMsg != "") {
            (_a = this.disco) === null || _a === void 0 ? void 0 : _a.send(this.discoDisconnectMsg);
        }
    }
}
export function pollFunction(pollFunc, isAgain, interval = 500) {
    return new Promise((resolve, reject) => {
        let attempt = 0;
        var tryAgain;
        tryAgain = () => {
            attempt += 1;
            pollFunc()
                .then((res) => {
                if (isAgain(res, null, attempt)) {
                    setTimeout(() => {
                        tryAgain();
                    }, interval);
                }
                else {
                    resolve(res);
                }
            })
                .catch((err) => {
                if (isAgain(null, err, attempt)) {
                    setTimeout(() => {
                        tryAgain();
                    }, interval);
                }
                else {
                    reject(err);
                }
            });
        };
        tryAgain();
    });
}
export function buildSms(topic, fromRole, fromPub, tgtRole, tgtPub) {
    if (tgtPub) {
        tgtRole = tgtRole + "." + tgtPub;
    }
    return `neg.${topic}.sms.${fromRole}.${fromPub}.to.${tgtRole}`;
}
